import {Component, Input, ViewChild} from '@angular/core';
import {StudentTicketMandateHolderDto} from '../../../../../models/student-ticket/payment/StudentTicketMandateHolderDto';
import {WizardStepComponent} from '../../wizard-step-component.interface';
import {MandateHolderFormComponent} from '../../../../../shared/mandate-holder-form/mandate-holder-form.component';

@Component({
  selector: 'app-payment-step',
  standalone: true,
  imports: [MandateHolderFormComponent],
  templateUrl: './payment-step.component.html',
})
export class PaymentStepComponent implements WizardStepComponent {

  @Input() initialData: StudentTicketMandateHolderDto | null;

  @ViewChild(MandateHolderFormComponent) private mandateHolderForm: MandateHolderFormComponent;

  isValid(): boolean {
    return this.mandateHolderForm.isValid();
  }

  getValue(): StudentTicketMandateHolderDto {
    return this.mandateHolderForm.getFormValue();
  }
}
